import { Buffer } from 'buffer';

export const base64Encode = (str) => Buffer.from(str, 'utf8').toString('base64');
export const base64Decode = (str) => Buffer.from(str, 'base64').toString('utf8');